<template>
  <div class="content-background">
    <div class="add-content">
      <div class="content">
        <div>
          <p class="content-label required">名称</p>
          <el-input
            v-model.trim="name"
            type="text"
            class="content-title-input"
            placeholder="请输入培训类型名称"
            clearable
            maxlength="45" :show-word-limit="true"></el-input>
            <span class="limit" v-if="name && name.length > 30">{{name? name.length: 0}}/45</span>
        </div>
        <div>
          <div class="content-topic-divider"></div>
          <div class="content-footer">
            <el-button class="save" @click="$router.back()">取消</el-button>
            <el-button class="publish" @click="save" v-if="permissions.activity_type_add">{{ isEdit ? '保存' : '添加'}}</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/styles/content.scss'
import { mapGetters } from 'vuex';
import Api from '@/api/app/activity';

export default {
  data() {
    return {
      name: '',
      isEdit: '',
      id: ''
    }
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  created() {
    this.isEdit = this.$route.path.includes('edit');
    if (this.isEdit && !isNaN(this.id)) {
      this.id = this.$route.params.id;
      this.name = this.$route.query.name;
    }
  },
  methods: {
    async save () {
      const name = this.name;
      if (name === '' || name.trim() === '') {
        this.$message({
          message: '培训类型名称不能为空',
          type: 'warning',
        });
        return;
      }
      const data = {};
      data.name = name;
      let response;
      if (this.isEdit) {
        response = await this.requestWrapper(Api.editActivityType, this.id, data);
      } else {
        response = await this.requestWrapper(Api.addActivityType, data);
      }
      if (response.code !== 0) {
        this.$message.error(response.msg);
      } else {
        this.$router.back();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content-background {
  .add-content {
    .required::before {
      content: "*";
      color: #f56c6c;
      margin-right: 4px;
    }
    .limit {
      font-size: 14px;
      color: #AFAFAF;
      margin-left: 12px;
    }
    .content-area {
      width: 920px;
      position: relative;
      .content-image-input {
        width: 100%;
        position: relative;
      }
      .limit {
        position: absolute;
        bottom: 8px;
        right: 8px;
      }
    }
    .content-footer {
      text-align: right;
    }
  }
}
</style>
